import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../component/Header";
import DiamondsFour from "../../component/SvgIcons/DiamondsFour";
import { useSwal } from "../../services/SweetAlert";
import api from "../../services/axios";
import IconDate from "../../component/SvgIcons/IconDate";
import IconDateActive from "../../component/SvgIcons/IconDateActive";
import EscalateTicketModal from "../../component/EscalateTicketModal";
import useBootstrapTooltip from "../../services/useBootstrapTooltip";
import { useAuth } from "../../context/AuthContext";
import { motion, AnimatePresence } from "framer-motion";
import CustomDropdown from "../../component/CustomDropdown";
import FaqSidebar from "../../component/TicketSidebar/FaqSidebar";
import AudioPlayer from "./AudioPlayer";
import utils from "../../utils/utils";
import CKEditorWrapper from "../../component/RichTextEditorFile";
import IconError from "../../component/SvgIcons/IconError";
const Recording =
  "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-5.mp3";

export default function ViewTicketHistory() {
  const navigate = useNavigate();
  const { alert } = useSwal();
  const { ticket_no } = useParams();
  const [ticketList, setTicketList] = useState([]);
  const [formData, setFormData] = useState({});
  const [originalStatus, setOriginalStatus] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showSidebar, setShowSidebar] = useState(true);
  const { authUser } = useAuth();
  const [statusData, setStatusData] = useState([]);
  const [agents, setAgents] = useState([]);
  const [QueryType, setQueryType] = useState([]);
  const [Priority_Id, setpriority] = useState([]);
  const [originalTicketData, setOriginalTicketData] = useState({});
  const [appType, setAppType] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const isEscalated =
    formData.escalated_to === "FA" ||
    formData.escalated_to === "GK" ||
    formData.escalated_to === "Gulf" ||
    formData.escalated_to === "Gulf Oil" ||
    formData.escalated_to === "Global Software";

  const getAgentName = (Code) => {
      console.log("🔎 Looking for agent with Code:", Code);
    const found = agents.find((agent) => agent.Code === Number(Code));
    return found ? found.Agent_Name : `User ${Code}`;
  };

  useEffect(() => {
    const fetchStatusData = async () => {
      try {
        const response = await api.post("/Ticket_Statuses");
        setStatusData(response.data.data || []);
      } catch (error) {
        console.error("Error fetching status data:", error);
      }
    };

    fetchStatusData();

    const fetchAgents = async () => {
      try {
        const res = await api.post("/list_agent");
        if (res.data && Array.isArray(res.data.data)) {
          setAgents(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching agents:", error);
      }
    };

    fetchAgents();

    const fetchpriority = async () => {
      try {
        const res = await api.post("/getpriority_list");

        if (res.data.data && Array.isArray(res.data.data)) {
          const transformed = res.data.data.map((item) => ({
            value: item.Id,
            label: item.DisplayName,
            color: item.ColorCode || "#000", // Default to black if no color is provided
          }));
          // setAppType(transformed);
          setpriority([
            { value: "", label: "Select Priority  Type", disabled: true },
            ...transformed,
          ]);
        } else {
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch application types:", error);
      }
    };
    fetchpriority();

    const fetchQueryType = async () => {
      try {
        const res = await api.post(
          "/getAllTemplates",
          {},
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        const dataArr = Array.isArray(res.data.data) ? res.data.data : [];

        if (dataArr.length > 0) {
          const transformed = dataArr.map((item) => ({
            value: item.TemplateID?.toString() ?? "",
            label: item.Query ?? "(no query text)",
            issueDetails: item.Issue ?? "",
            remarks: item.Remarks ?? "",
          }));

          setQueryType([
            { value: "", label: "Select Query Template", disabled: true },
            ...transformed,
          ]);
        } else {
          console.warn("No templates found.");
        }
      } catch (err) {
        console.error("Failed to fetch templates:", err);
      }
    };

    fetchQueryType();
    const fetchAppTypes = async () => {
      try {
        const res = await api.post("/Application_Types");
        if (res.data.data && Array.isArray(res.data.data)) {
          const transformed = res.data.data.map((item) => ({
            value: item.Id,
            label: item.DisplayName,
          }));
          // setAppType(transformed);
          setAppType([
            { value: "", label: "Select Application Type", disabled: true },
            ...transformed,
          ]);
        } else {
          console.warn("Unexpected data format:", res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch application types:", error);
      }
    };
    fetchAppTypes();
  }, []);

  const filteredStatusData = statusData.filter((status) => {
    const name = status.Name;

    // Show 'ReOpened' only if the original status is 'Closed' AND user is from 'Global Assist'
    if (name === "ReOpened") {
      return (
        originalStatus === "Closed" &&
        authUser?.Agents_Company === "Global Assist"
      );
    }

    // Exclude 'Escalated'
    if (name === "Escalated") {
      return false;
    }

    // If ticket is Closed, do NOT show 'Open' or 'InProgress'
    if (
      originalStatus === "Closed" &&
      (name === "Open" || name === "InProgress")
    ) {
      return false;
    }

    return true; // default allow
  });

  useEffect(() => {
    utils.saveRecentSearch("View Ticket", window.location.pathname);
  }, []);

  const fetchTicketDetails = async () => {
    try {
      const res = await api.post("/list_ticket",{Ticket_No: ticket_no});
      // const res = await api.post("/list_ticket", {
      //   isAdmin: authUser.isAdmin,
      //   Code: authUser?.Code,
      //   Ticket_No: ticket_no,
      //   Agents_Company: authUser?.Agents_Company,
      // });
      const tickets = res?.data?.data || [];
      if (tickets.length > 0) {
        setTicketList(tickets);
        setSelectedIndex(0);
        setFormData(tickets[0]);
        setOriginalTicketData(tickets[0]);
        setOriginalStatus(tickets[0].Status_Name);
      } else {
        alert("warning", "Ticket not found");
      }
    } catch (error) {
      console.error("Error fetching tickets:", error);
    } finally {
      setLoading(false);
    }
  };

  // Then call it inside useEffect
  useEffect(() => {
    setTicketList([]);
    fetchTicketDetails();
  }, [ticket_no]);

  const handleRowClick = (ticket, index) => {
    setSelectedIndex(index);
    setFormData(ticket);
    setOriginalStatus(ticket.Status_Name);
  };

  const getFieldError = (name, value) => {
    switch (name) {
      case "Issue_Details":
        return !value || stripHtml(value).trim() === ""
          ? "Issue Details cannot be empty."
          : "";
      case "Action_Remarks":
        return !value || value.trim() === ""
          ? "Remarks cannot be empty."
          : "";
      default:
        return "";
    }
  };

  const validateField = (name, value) => {
    const error = getFieldError(name, value);
    setFormErrors((prev) => ({ ...prev, [name]: error }));
    return !error;
  };

  const handleChange = async (eOrName, maybeValue) => {
    if (typeof eOrName === "string") {
      setFormData((prev) => ({ ...prev, [eOrName]: maybeValue }));

      if (eOrName === "Query" && maybeValue) {
        try {
          const selectedTemplate = QueryType.find(
            (template) => template.value === maybeValue
          );
          if (selectedTemplate) {
            setFormData((prev) => ({
              ...prev,
              Issue_Details: `${prev.Issue_Details?.trim() || ""
                }<hr/><strong>New Issue:</strong><br/>${selectedTemplate.issueDetails?.trim() || ""
                }`,
              Remarks: selectedTemplate.remarks || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching template details:", error);
        }
      }
      validateField(eOrName, maybeValue);
    } else {
      const { name, value } = eOrName.target;
      setFormData((prev) => ({ ...prev, [name]: value }));

      if (name === "Query" && value) {
        try {
          const selectedTemplate = QueryType.find(
            (template) => template.value === value
          );
          if (selectedTemplate) {
            setFormData((prev) => ({
              ...prev,
              Issue_Details: selectedTemplate.issueDetails || "",
              Remarks: selectedTemplate.remarks || "",
            }));
          }
        } catch (error) {
          console.error("Error fetching template details:", error);
        }
      }
      validateField(name, value);
    }
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    // Format: DD-MM-YYYY
    const formattedDate = date.toLocaleDateString("en-GB").replaceAll("/", "-");

    // Format: hh:mm AM/PM
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${formattedDate} ${formattedTime}`;
  };
  const stripHtml = (html) => {
    const tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  };
  useBootstrapTooltip([ticketList]);

  const isFormChanged = () => {
    return (
      formData.Status_Name !== originalTicketData.Status_Name ||
      formData.Issue_Details !== originalTicketData.Issue_Details ||
      formData.Phone_no !== originalTicketData.Phone_no ||
      formData.Recording_Path !== originalTicketData.Recording_Path ||
      formData.Action_Remarks !== originalTicketData.Action_Remarks ||
      formData.Priority_Id !== originalTicketData.Priority_Id ||
      formData.Query !== originalTicketData.Query ||
      formData.escalated_Status !== originalTicketData.escalated_Status ||
     formData.Designation !== originalTicketData.Designation
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    let isValid = true;

    ["Issue_Details", "Action_Remarks"].forEach((field) => {
      const error = getFieldError(field, formData[field]);
      if (error) {
        newErrors[field] = error;
        isValid = false;
      }
    });
    setFormErrors(newErrors);

    if (!isValid) {
      alert("warning", "Please fill in all required fields correctly.");
      return;
    }

    if (!isFormChanged()) {
      alert("warning", "No changes detected. Please modify something before saving.");
      return;
    }
    setLoading(true);

    try {
      const payload = {
        Ticket_No: formData.Ticket_No,
        User: formData.userId || localStorage.getItem("user"),
        Issue_Details: formData.Issue_Details,
        // Status: formData.Status_Name,
        Designation :formData.Designation,
        Phone_no: formData.Phone_no,
        Recording_Path: formData.Recording_Path || "",
        Remarks: formData.Action_Remarks,
        Priority_Id: formData.Priority_Id,
        Query: formData.Query,
        Contact_Person : formData.Contact_Person,
        Status:
          isEscalated && formData.escalated_Status === "Closed"
            ? "Closed"
            : isEscalated
              ? originalTicketData.Status_Name
              : formData.Status_Name,

        escalated_Status: isEscalated ? formData.escalated_Status : "",
        escalated_to: isEscalated ? formData.escalated_to : "",
      };

      const { status, data } = await api.post(
        "/add_action_to_ticket",
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (status === 200) {
        alert("success", "Ticket updated successfully.");

        fetchTicketDetails();
        navigate(`/view-ticket-history/${ticket_no}`);
      } else {
        alert("error", data.message || "Unexpected response");
      }
    } catch (err) {
      console.error("Submission error:", err);
      const message =
        err.response?.data?.message || err.message || "Submission failed";
      alert("error", message);
    } finally {
      setLoading(false);
    }
  };

  const isLatestTicket = selectedIndex === 0;

  const handleEscalationSave = async (escalationData) => {
    const updatedFormData = {
      ...formData,
      ...escalationData,
    };
    setFormData(updatedFormData);
    const requiredFields = [
      { name: "Customer_Code", message: "Please select customer." },
      { name: "Contact_Person", message: "Contact Person is required." },
      { name: "Status", message: "Status is required." },
      { name: "Issue_Details", message: "Please provide issue details." },
    ];
    const newErrors = {};
    let isValid = true;

    requiredFields.forEach(({ name, message }) => {
      if (!updatedFormData[name] || updatedFormData[name].toString().trim() === "") {
        newErrors[name] = message;
        isValid = false;
      }
    });
    setFormErrors(newErrors);

    if (!isValid) {
      await alert("warning", "Please fill in all required fields correctly.");
      return;
    }

    const payload = {
      Ticket_No: updatedFormData.Ticket_No,
      User:
        formData.User?.Code || JSON.parse(localStorage.getItem("user"))?.Code,
      Customer_Code: updatedFormData.Customer_Code,
      Contact_Person: updatedFormData.Contact_Person,

      Phone_no: updatedFormData.Phone_no,
      Email_Id: updatedFormData.Email_Id,
      Application_Name: updatedFormData.Application_Name,
      Issue_Details: updatedFormData.Issue_Details,
      Status: updatedFormData.Status,
      Query: updatedFormData.Query,
      Remarks: updatedFormData.Remarks,
      tags: updatedFormData.tags,
      Priority_Id: updatedFormData.Priority_Id,
      Designation: updatedFormData.Designation,
      Customer_Type: updatedFormData.Customer_Type,
      Designation: updatedFormData.Designation,
      escalated_to: updatedFormData.escalated_to,
      escalated_Status: updatedFormData.escalated_Status,
    };

    try {
      setLoading(true);
      const formPayload = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formPayload.append(key, value);
        }
      });

      if (updatedFormData.picture) {
        formPayload.append("picture", updatedFormData.picture);
      }

      const res = await api.post("/add_action_to_ticket", formPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // const newTicketNo = res?.data?.Ticket_No;

      await alert("success", `Ticket Escalate successfully.`);

      setFormData({
        Ticket_No: "",
        Customer_Code: "",
        Contact_Person: "",
        User: authUser?.Code || "",
        Phone_no: "",
        Email_Id: "",
        Application_Name: "",
        Issue_Details: "",
        Status: "",
        Designation:"",
        search: "",
        Customer_Type: "",
        Query: "",
        Remarks: "",
        tags: "",
        Priority_Id: 1,
        Designation: "",
        picture: null,
        escalated_to: "",
        escalated_Status: "",
      });
    } catch (err) {
      setLoading(false);
      const message = err.response?.data?.message;
      await alert("warning", message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const isFormValidForEscalation = (data) => {
    return (
      !!data.Customer_Code &&
      !!data.Contact_Person &&
      // (!!data.Email_Id || !!data.Phone_no) &&
      // !!data.Status &&
      !!data.Issue_Details
    );
  };

  return (
    <div className="dashboard">
      <Header
        title
        subtitle="View Ticket History"
        backbtn={"/tickets-list"}
        setShowSidebar={setShowSidebar}
        searchbar
      />
      <motion.div
        className={`center-content custom-container ${!showSidebar ? "hide-sidebar" : ""}`}
        transition={{ duration: 0.5, ease: "easeInOut" }}
      >
        <div className="container">
          <div className="pagegap d-flex flex-column">
            <div className="main-table">
              <div className="tablespace mb-4">
                <h2 className="create-titles create-titles02 mb-3 d-flex align-items-center">
                  <DiamondsFour />
                  <span>
                    {ticketList?.[0]?.Ticket_No || "Loading..."} -{" "}
                    {ticketList?.[0]?.Customer_Name || ""}
                  </span>
                  : Ticket History
                </h2>
                <div className="table-responsive">
                  <table className="table table-hover my-0">
                    <thead className="thead-light">
                      <tr>
                        <th width="45">Sr. No</th>
                        <th width="150">
                          <IconDate /> Date & Time
                        </th>
                        {/* <th width="90">Ticket Number</th> */}
                        {/* <th width="100">Customer Name</th> */}
                        <th width="100">User</th>
                        <th width="100">Escalated To</th>
                        <th>Issue Type</th>
                        {authUser?.Agents_Company?.trim() ===
                          "Global Assist" && <th width="150">Recorded Call</th>}

                        <th width="100">Status</th>
                        <th style={{ padding: "0px" }} width="1"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ padding: "5px" }}></td>
                      </tr>
                    </tbody>
                    <tbody>
                      {ticketList.map((ticket, index) => (
                        <tr
                          key={ticket.Ticket_No}
                          className={
                            selectedIndex === index ? "selected-row" : ""
                          }
                          onClick={() => handleRowClick(ticket, index)}
                        >
                          <td className="text-center">
                            <span>{ticket.Call_Sr_No}</span>
                          </td>
                          <td>
                            <figure
                              className="d-flex align-items-center custom-control-label"
                              style={{ cursor: "pointer" }}
                            >
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={`customCheckDisabled-${index}`}
                                // checked={selectedIndex === index}
                                checked={index === 0}
                                disabled={index !== 0}
                                readOnly
                              />
                              <label
                                className="tablecheckbox position-relative"
                                htmlFor={`customCheckDisabled-${index}`}
                              >
                                <div className="rounded-circle" />
                                <div className="colorblack ticketcircle">
                                  {selectedIndex === index ? (
                                    <IconDateActive />
                                  ) : (
                                    <IconDate />
                                  )}{" "}
                                  {formatDateTime(
                                    ticket.Create_Date_Time_Stamp
                                  )}
                                </div>
                              </label>
                            </figure>
                          </td>

                          {/* <td>
                            <div className="colorblack ">
                              {ticket.Ticket_No}
                            </div>
                          </td>
                          <td>{ticket.Customer_Name || ""}</td> */}
                          <td>
                            <span>{getAgentName(ticket.User)}</span>
                          </td>

                          <td>
                            <Link
                              to={`/view-ticket-history/${ticket.Ticket_No}`}
                              className="colorblack d-flex"
                            >
                              {ticket.escalated_to?.includes("FA") && (
                                <img
                                  className="exgrid"
                                  src="../images/fa.svg"
                                  alt="FA"
                                />
                              )}
                              {ticket.escalated_to?.includes("GK") && (
                                <img
                                  className="exgrid"
                                  src="../images/gk.svg"
                                  alt="GK"
                                />
                              )}
                              {ticket.escalated_to?.includes("Gulf") && (
                                <img
                                  className="exgrid"
                                  src="../images/gf.svg"
                                  alt="GF"
                                />
                              )}
                              {ticket.escalated_to?.includes(
                                "Global Software"
                              ) && (
                                  <img
                                    className="exgrid"
                                    src="../images/gs.svg"
                                    alt="GS"
                                  />
                                )}

                              {/* Show the text of escalated_to as well */}
                              {/* {row.escalated_to} */}
                            </Link>
                          </td>

                          <td
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title={stripHtml(ticket.Issue_Details)}
                          >
                            {(() => {
                              const text = stripHtml(ticket.Issue_Details);
                              const words = text.split(" ");
                              const truncated = words.slice(0, 10).join(" ");
                              return (
                                truncated + (words.length > 10 ? "..." : "")
                              );
                            })()}
                          </td>

                          {authUser?.Agents_Company?.trim() === "Global Assist" && (
                            <td>
                              <AudioPlayer url={Recording} />
                            </td>
                          )}

                          <td align="center">
                            <div
                              className={`statusbtn ${ticket.Status_Name?.toLowerCase().replace(
                                /\s+/g,
                                "-"
                              )}`}
                            >
                              {ticket.Status_DisplayName}
                            </div>
                          </td>
                          <td style={{ padding: "4px" }} width="1" />
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <AnimatePresence mode="wait">
                <motion.form
                  key={formData.Ticket_No} // triggers animation on change
                  className="createticket myform d-flex flex-column justify-content-between"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.3 }}
                  onSubmit={handleSubmit}
                >
                
                  <div className="form-savebtns newformbutton d-flex flex-wrap flex-xxl-row align-items-center">
                    <div className="status-buttons">
                      {/* Show escalate button if latest, not already escalated or closed */}
                      {isLatestTicket &&
                        originalStatus !== "Escalated" &&
                        originalStatus !== "Closed" && (
                          <EscalateTicketModal
                            onSave={handleEscalationSave}
                            disabled={!isFormValidForEscalation(formData)}
                          />
                        )}

                      {filteredStatusData.map((status) => {
                        const name = status.Name;
                        const isEscalated =
                          formData.escalated_to === "FA" ||
                          formData.escalated_to === "GK" ||
                          formData.escalated_to === "Gulf" ||
                          formData.escalated_to === "Global Software";

                        const showThisButton = (() => {
                          if (!isLatestTicket) return false;

                          if (originalStatus === "Escalated") {
                            return name === "InProgress" || name === "Closed";
                          }

                          if (name === "Open") {
                            return originalStatus === "Open";
                          }

                          return true;
                        })();

                          const isActive = isEscalated
                      ? (formData.escalated_Status
                          ? formData.escalated_Status.toLowerCase() === name.toLowerCase()
                          : name.toLowerCase() === "inprogress")
                      : formData.Status_Name?.toLowerCase() === name.toLowerCase();

                        const pretty = name.replace(/([A-Z])/g, " $1").trim();

                        return showThisButton ? (
                          <button
                            key={name}
                            type="button"
                            className={`btn statusbtnform ${
                              isActive ? "active" : ""
                            }`}
                            onClick={() => {
                              if (name.toLowerCase() === "reopened") {
                                navigate(
                                  `/reopen-ticket/${formData.Ticket_No}`
                                );
                              } else {
                                setFormData((prev) => ({
                                  ...prev,
                                  ...(isEscalated
                                    ? { escalated_Status: name }
                                    : { Status_Name: name }),
                                }));
                              }
                            }}
                          >
                            {pretty}
                          </button>
                        ) : null;
                      })}
                    </div>

                    <div className="d-flex gap-3">
                      <Link to="/tickets-list" className="btn cancelbtn">
                        Close
                      </Link>
                      {isLatestTicket && (
                        <button
                          type="submit"
                          className="btn btngradiant"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save"}
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="create-form d-flex flex-column">
                    <div className="form-row formresponsive">
                      <div className="form-group">
                        <label>Ticket Number</label>
                        <input
                          type="name"
                          name="Ticket_No"
                          className="form-control"
                          placeholder="Enter Ticket Number"
                          value={formData.Ticket_No}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Customer Name</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="customer name"
                          value={formData.Customer_Name}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Customer Code</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="customer code"
                          value={formData.Customer_Code}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Designation</label>
                        <input
                          type="text"
                          name="Designation"
                          className="form-control"
                          placeholder="Enter Designation"
                          value={formData.Designation || ""}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Customer Type</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="customer type"
                          value={formData.Customer_Type}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Contact Person</label>
                        <input
                          type="text"
                          name="Contact_Person"
                          className="form-control"
                          placeholder="Enter Name"
                          value={formData.Contact_Person}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          name="Contact_Email_Id"
                          className="form-control"
                          placeholder="Enter Email"
                          value={formData.Contact_Email_Id}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Phone Number</label>
                        <input
                          type="phonenumber"
                          name="Phone_no"
                          className="form-control"
                          placeholder="Enter Phone Number"
                          value={formData.Phone_no}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label>Application</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Application"
                          value={
                            appType.find(
                              (item) =>
                                item.value.toString() ===
                                formData.Application_Name?.toString()
                            )?.label || ""
                          }
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Priority</label>
                        <CustomDropdown
                          options={Priority_Id}
                          placeholder="Select Priority Type"
                          name="Priority_Id"
                          value={formData.Priority_Id}
                          onChange={(val) => handleChange("Priority_Id", val)}
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Query</label>
                        <input
                          type="text"
                          name="Query"
                          className="form-control"
                          readOnly
                          value={
                            QueryType.find(
                              (item) =>
                                item.value?.toString() ===
                                formData.Query?.toString()
                            )?.label || ""
                          }
                        />
                      </div>

                      <div className="form-group">
                        <label>Tags</label>
                        <input
                          type="text"
                          name="tags"
                          className="form-control"
                          placeholder="Enter tags"
                          value={formData.tags}
                        // onChange={handleChange}
                        />
                      </div>
                    </div>

                    <div className={`form-group texteditor d-block ${formErrors.Issue_Details ? "fieldrequire" : ""}`}>
                      <label>Issue</label>
                      <CKEditorWrapper
                        value={formData.Issue_Details}
                        onChange={(html) => handleChange("Issue_Details", html)}
                      />
                      <small className="hide">
                        <IconError />
                      </small>
                    </div >

                    <div
                      className={`form-group texteditor d-block ${formErrors.Action_Remarks ? "fieldrequire" : ""
                        }`}
                    >
                      <label> Remark</label>

                      <CKEditorWrapper
                        value={formData.Action_Remarks}
                        onChange={(html) =>
                          handleChange("Action_Remarks", html)
                        }
                      />
                      <small className="hide">
                        <IconError />
                      </small>
                    </div >
                  </div >
                </motion.form >
              </AnimatePresence >
            </div >
          </div >

          <div className="customer-rightside">
            <AnimatePresence>
              <motion.div
                key="faqSidebar"
                className="faqsidebar"
                initial={{ x: 300, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: 300, opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                <FaqSidebar
                  customerCode={formData.Customer_Code}
                  agentsCompany={authUser?.Agents_Company}
                />
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </motion.div>
    </div>
  );
}